import * as React from "react"

import Details from "Catalog/Edit/shared/components/Details"
import useCatalogNavigation from "Catalog/shared/hooks/useCatalogNavigation"
import useEditor from "shared/hooks/useEditor"
import useNavigateNoUpdate from "shared/hooks/useNavigateNoUpdate"
import { IDeal } from "shared/hubrise/models"

const Delete = ({ deal }: { deal: IDeal }): JSX.Element => {
  const { editor } = useEditor()
  const { catalogNavigation } = useCatalogNavigation()
  const navigate = useNavigateNoUpdate()

  const handleClick = (): void => {
    navigate(catalogNavigation.editNextPath("deals"))
    editor.deal.delete(deal.id)
  }

  return <Details.TopbarButton onClick={handleClick} code="delete" />
}

export default Delete
